import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import { ReactComponent as Logo } from "../assets/browser.svg";
import { ReactComponent as OrderPass } from "../assets/orderPass-logo.svg";
import { ReactComponent as OrderPassArabic } from "../assets/orderPass-logo-ar.svg";
import MyStepper from "../MyStepper";
import UserForm from "./UserForm";
import { connect } from "react-redux";
import ActionButton from "../../ActionButton";
import { isValidPhoneNumber } from "react-phone-number-input";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MuiPhoneNumber from "material-ui-phone-number";
import PhoneIcon from "@material-ui/icons/Phone";
import instance from "../../../store/actions/instance";
//Actions
import {
  clearOrderPassGuestBypass,
  saveAddress,
  saveCustomerContact,
  setOrderPassGuestBypass,
  setBranchDeliveryCharge,
  setOrderPassData,
  refreshStorefrontOrderPassData,
  updateMOV,
} from "../../../store/actions";
import SignUp from "../../common/SignUp";
import VerifyPhone from "./VerifyPhone";

import { createCustomerWithAddressAndPhone } from "../../../store/actions/auth";
import {
  fetchDeliveryCharges,
  fetchTargetedDeliveryChargesForAreas,
} from "../../../store/actions/store";
import {
  buildOrderPassRedirectUrl,
  canUseSocialAuth,
  clearOrderPassReturnParamsFromSearch,
  getOrderPassDomain,
  getOrderPassReturnData,
  getOrderPassSavedAreaNames,
  getStorefrontOrderPassSyncData,
  hydrateOrderPassAddresses,
  isDeliveryServiceAvailable,
  isOrderPassEnabled,
  isOrderPassPhoneVerified,
  normalizeOrderPassPhone,
  isPickupServiceAvailable,
  shouldRequireOrderPassVerification,
  shouldSyncStorefrontOrderPassData,
} from "../../../Helpers/orderPass";
import {
  orderPassButtonStyle,
  orderPassModalActionsStyle,
  orderPassModalContentStyle,
  orderPassModalPaperStyle,
  orderPassModalTitleStyle,
} from "../../../Helpers/orderPassUi";
const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};
const getPhoneDigits = (phone) => (phone || "").replace(/\D/g, "");
const isEgyptPhone = (phone) => getPhoneDigits(phone).startsWith("20");
const isEgyptianMobilePhoneNumber = (phone) => {
  if (!phone) return false;
  const digits = getPhoneDigits(phone);
  if (!digits.startsWith("20")) return false;
  const nationalNumber = digits.slice(2);
  if (nationalNumber.startsWith("0")) {
    return /^(010|011|012|015)\d{8}$/.test(nationalNumber);
  }
  return /^(10|11|12|15)\d{8}$/.test(nationalNumber);
};
const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const normalizeCountryName = (name) =>
  `${name || ""}`
    .replace(/[\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g, "")
    .trim()
    .toLowerCase();

class index extends Component {
  state = {
    name: this.props.auth.user?.name || "",
    civilID: "",
    email: this.props.auth.user?.email || "",
    phone: this.props.auth.user?.phone || "",
    birthday: !!this.props.auth.user?.birth_date
      ? new Date(
          this.props.auth.user?.birth_date.substring(0, 4),
          this.props.auth.user?.birth_date.substring(5, 7),
          this.props.auth.user?.birth_date.substring(8, 10),
        )
      : new Date(),
    nameError: false,
    emailError: false,
    nameLengthError: false,
    civilIDError: false,
    phoneError: false,
    phoneErrorText: "",
    countryDialCode: "",
    optInMarketing: this.props.auth.user?.opt_in_marketing,
    contactChannel: this.props.auth.user?.contact_channel,

    showForm:
      !shouldRequireOrderPassVerification(
        this.props.settings,
        this.props.customerContact || {
          phone: this.props.auth.user?.phone,
        },
        this.props.orderPassVerifiedPhone,
        this.props.orderPassGuestBypassPhone,
      ) &&
      (!!this.props.auth.user || !canUseSocialAuth(this.props.settings)),

    phoneFieldKey: Math.random() * 99999,

    verifyPhoneModalOpen: false,
    orderPassAddressDialogOpen: false,
    orderPassAddressOptions: [],
    showAllOrderPassAddressOptions: false,
    processingOrderPassReturn:
      isOrderPassEnabled(this.props.settings) &&
      !!getOrderPassReturnData(this.props.location.search),
    orderPassHasAccount: null,
    redirectingToOrderPass: false,
    orderPassPhoneCheckLoading: false,
    orderPassHasSavedAddresses: null,
    orderPassCheckedPhone: "",
  };

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    const cc = this.props.customerContact;

    if (cc) {
      this.setState((prevState) => ({
        name: cc.name || "",
        civilID: cc.civilID || "",
        email: cc.email || "",
        phone: cc.phone || "",
        birthday: cc.birth_date || "",
        optInMarketing: cc.hasOwnProperty("opt_in_marketing")
          ? cc.opt_in_marketing
          : prevState.optInMarketing,
        contactChannel: cc.hasOwnProperty("contact_channel")
          ? cc.contact_channel
          : prevState.contactChannel,
      }));
    }

    if (
      !cc &&
      (this.props.auth.user?.phone ||
        this.props.auth.user?.name ||
        this.props.auth.user?.email)
    ) {
      this.setState({
        name: this.props.auth.user?.name || "",
        email: this.props.auth.user?.email || "",
        phone: this.props.auth.user?.phone || "",
      });
    }

    const orderPassReturnData = getOrderPassReturnData(
      this.props.location.search,
    );

    if (
      orderPassReturnData &&
      this.props.settings?.enable_orderpass === false
    ) {
      const cleanedSearch = clearOrderPassReturnParamsFromSearch(
        this.props.location.search,
      );
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: cleanedSearch,
      });
    }

    if (orderPassReturnData && this.shouldUseOrderPass()) {
      await this.handleHostedOrderPassReturn();
      return;
    }

    if (!this.shouldUseOrderPass()) {
      if (
        !this.state.showForm &&
        (this.props.auth.user || !canUseSocialAuth(this.props.settings))
      ) {
        this.setState({ showForm: true });
      }
      return;
    }

    if (this.shouldUseOrderPass()) {
      const initialPhone =
        cc?.phone || this.props.auth.user?.phone || this.state.phone || "";
      const shouldShowForm = !this.requiresOrderPassVerification(initialPhone);

      this.setState({
        showForm: shouldShowForm,
      });

      if (!shouldShowForm && this.isValidPhoneValue(initialPhone)) {
        this.queueOrderPassAddressCheck(initialPhone);
      }
      if (
        shouldShowForm &&
        this.isValidPhoneValue(initialPhone) &&
        !this.isOrderPassVerified(initialPhone)
      ) {
        this.queueOrderPassAddressCheck(initialPhone);
      }
    }
  };

  componentWillUnmount = () => {
    if (this.orderPassAddressCheckTimeout) {
      window.clearTimeout(this.orderPassAddressCheckTimeout);
    }
  };

  resetOrderPassAddressCheck = () => {
    if (this.orderPassAddressCheckTimeout) {
      window.clearTimeout(this.orderPassAddressCheckTimeout);
    }
    this.setState({
      orderPassPhoneCheckLoading: false,
      orderPassHasAccount: null,
      orderPassHasSavedAddresses: null,
      orderPassCheckedPhone: "",
    });
  };

  queueOrderPassAddressCheck = (phone = this.state.phone) => {
    if (!this.shouldUseOrderPass()) return;

    const normalizedPhone = normalizeOrderPassPhone(phone);
    if (!this.isValidPhoneValue(phone)) {
      this.resetOrderPassAddressCheck();
      return;
    }

    if (
      this.state.orderPassCheckedPhone &&
      normalizeOrderPassPhone(this.state.orderPassCheckedPhone) ===
        normalizedPhone &&
      this.state.orderPassHasSavedAddresses !== null &&
      this.state.orderPassHasAccount !== null
    ) {
      return;
    }

    if (this.orderPassAddressCheckTimeout) {
      window.clearTimeout(this.orderPassAddressCheckTimeout);
    }

    this.setState({
      orderPassPhoneCheckLoading: true,
      orderPassHasAccount: null,
      orderPassHasSavedAddresses: null,
      orderPassCheckedPhone: phone,
    });

    this.orderPassAddressCheckTimeout = window.setTimeout(async () => {
      try {
        const res = await instance.post("/order_pass/check_phone_addresses/", {
          number: phone,
          domain: getOrderPassDomain(this.props.settings, this.props.store),
        });

        if (normalizeOrderPassPhone(this.state.phone) !== normalizedPhone) {
          return;
        }

        this.setState({
          orderPassPhoneCheckLoading: false,
          orderPassHasAccount: !!res.data?.has_account,
          orderPassHasSavedAddresses: !!res.data?.has_addresses,
          orderPassCheckedPhone: phone,
        });
      } catch (error) {
        if (normalizeOrderPassPhone(this.state.phone) !== normalizedPhone) {
          return;
        }

        this.setState({
          orderPassPhoneCheckLoading: false,
          orderPassHasAccount: false,
          orderPassHasSavedAddresses: false,
          orderPassCheckedPhone: phone,
        });
      }
    }, 350);
  };

  handleChange = (e, eventPhone) => {
    const { settings } = this.props;

    if (eventPhone) {
      this.setState({ countryDialCode: eventPhone.dialCode });
    }
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        this.setState({ phone: e }, () => {
          if (this.shouldUseOrderPass() && !this.isOrderPassVerified(e)) {
            this.queueOrderPassAddressCheck(e);
          }
        });
      } else {
        this.setState({ phoneFieldKey: Math.random() * 999999 });
        this.resetOrderPassAddressCheck();
      }
      if (e.length >= this.state.phone.length)
        this.setState({ phoneError: false, phoneErrorText: "" });
    } else {
      this.setState({ [e.target.name]: e.target.value });
      if (this.state.name?.trim()?.length < 25 && this.state.nameLengthError)
        this.setState({ nameLengthError: false });
      if (this.state.name && this.state.nameError)
        this.setState({ nameError: false });
      if (
        settings.email_required &&
        this.state.email &&
        validateEmail(this.state.email) &&
        this.state.emailError
      ) {
        this.setState({ emailError: false });
      } else if (this.state.civilID && this.state.civilIDError)
        this.setState({ civilIDError: false });
    }
  };

  isOrderPassVerified = (
    phone = this.state.phone || this.props.customerContact?.phone,
  ) => isOrderPassPhoneVerified({ phone }, this.props.orderPassVerifiedPhone);

  hasChangedVerifiedOrderPassPhone = (
    phone = this.state.phone || this.props.customerContact?.phone,
  ) =>
    this.shouldUseOrderPass() &&
    !!this.props.orderPassVerifiedPhone &&
    !isOrderPassPhoneVerified({ phone }, this.props.orderPassVerifiedPhone);

  shouldUseOrderPass = () => isOrderPassEnabled(this.props.settings);

  requiresOrderPassVerification = (
    phone = this.state.phone || this.props.customerContact?.phone,
  ) =>
    shouldRequireOrderPassVerification(
      this.props.settings,
      { phone },
      this.props.orderPassVerifiedPhone,
      this.props.orderPassGuestBypassPhone,
    );

  isValidPhoneValue = (phone = this.state.phone) => {
    const isEgyptianPhone = isEgyptPhone(phone);
    return isEgyptianPhone
      ? isEgyptianMobilePhoneNumber(phone)
      : isValidPhoneNumber(phone) || isVirginPhoneNumber(phone);
  };

  validatePhone = (phone = this.state.phone) => {
    const isValidPhone = this.isValidPhoneValue(phone);

    if (!isValidPhone || this.state.countryDialCode == phone.substring(1)) {
      this.setState({ phoneError: true });
      return false;
    }

    this.setState({ phoneError: false, phoneErrorText: "" });
    return true;
  };

  hasCheckoutAddress = (address = this.props.address) => {
    if (!address || address.selectedDeliveryType === undefined) return false;
    if (address.selectedDeliveryType === 0)
      return !!address.country && !!address.area;
    if (address.selectedDeliveryType === 1) return !!address.pickupArea;
    return false;
  };

  hasCompleteLocalDeliveryAddress = (address = this.props.address) => {
    if (!address || address.selectedDeliveryType !== 0) return false;
    if (!address.country || !address.area) return false;

    const selectedCountry =
      (this.props.countries || []).find(
        (country) => `${country.id}` === `${address.country}`,
      ) || {};
    const countryName = selectedCountry.name || "";
    const selectedArea = this.props.settings.is_branch_based_ordering
      ? (this.props.branchDeliveryCharges || []).find(
          (bdc) => `${bdc.area_id}` === `${address.area}`,
        )
      : (this.props.areas || []).find(
          (area) => `${area.id}` === `${address.area}`,
        );
    const usesAddressLines =
      countryName === "International" ||
      selectedArea?.province_name === "Kashtat" ||
      selectedArea?.province_en === "Kashtat";
    const blockRequired =
      !this.props.settings.hide_block && countryName !== "UAE";
    const hasBlock = !blockRequired || !!`${address.block || ""}`.trim();
    const hasStreet = !!`${address.street || ""}`.trim();
    const hasBuilding =
      usesAddressLines || !!`${address.building || ""}`.trim();

    return hasBlock && hasStreet && hasBuilding;
  };

  hasCartItems = () =>
    this.props.cart.charged_items > 0 || this.props.cart.delivered_items > 0;

  isAreaSelectionOrderPassEntry = () => {
    const searchParams = new URLSearchParams(this.props.location.search || "");
    return (
      searchParams.get("orderpass_entry") === "area_select" ||
      this.props.history.location.state?.orderPassEntry === "area_select"
    );
  };

  requiresCheckoutAddress = ({ forceAreaSelection = false } = {}) =>
    (forceAreaSelection || this.hasCartItems()) &&
    (this.props.settings.enable_delivery || this.props.settings.enable_pickup);

  canSkipOrderPassForm = (customer) => {
    if (!customer?.name?.trim()) return false;
    if (
      this.props.settings.email_required &&
      !validateEmail(customer.email?.trim())
    )
      return false;
    if (this.props.settings.ask_for_civil_id && !customer.civilID) return false;
    return true;
  };

  isDeliveryOptionEnabled = () =>
    isDeliveryServiceAvailable({
      settings: this.props.settings,
      cart: this.props.cart,
    });

  isPickupOptionEnabled = () =>
    isPickupServiceAvailable({
      settings: this.props.settings,
      branches: this.props.branches,
      cart: this.props.cart,
    });

  shouldUsePickupFlowAfterOrderPass = () => {
    if (!this.isPickupOptionEnabled()) return false;
    if (this.props.address?.selectedDeliveryType === 1) return true;
    return !this.isDeliveryOptionEnabled();
  };

  getAvailableOrderPassAddresses = (
    addresses = this.getOrderPassAddressOptionSource(),
  ) =>
    (addresses || []).filter(
      (savedAddress) =>
        savedAddress?.orderPassMatched && savedAddress?.checkoutAddress,
    );

  hasUnchangedSavedContactPhone = () => {
    const savedPhone = normalizeOrderPassPhone(
      this.props.customerContact?.phone,
    );
    const currentPhone = normalizeOrderPassPhone(this.state.phone);
    return !!savedPhone && !!currentPhone && savedPhone === currentPhone;
  };

  currentAddressMatchesOrderPassAddress = (savedAddress) => {
    const currentAddress = this.props.address || {};
    if (!currentAddress || currentAddress.selectedDeliveryType !== 0) {
      return false;
    }

    if (
      currentAddress.orderPassAddressId &&
      savedAddress?.orderPassAddressId &&
      `${currentAddress.orderPassAddressId}` ===
        `${savedAddress.orderPassAddressId}`
    ) {
      return true;
    }

    const checkoutAddress = savedAddress?.checkoutAddress || {};
    return (
      `${currentAddress.country || ""}` ===
        `${checkoutAddress.country || ""}` &&
      `${currentAddress.area || ""}` === `${checkoutAddress.area || ""}` &&
      `${currentAddress.block || ""}`.trim() ===
        `${checkoutAddress.block || ""}`.trim() &&
      `${currentAddress.street || ""}`.trim() ===
        `${checkoutAddress.street || ""}`.trim() &&
      `${currentAddress.building || ""}`.trim() ===
        `${checkoutAddress.building || ""}`.trim() &&
      `${currentAddress.avenue || ""}`.trim() ===
        `${checkoutAddress.avenue || ""}`.trim() &&
      `${currentAddress.floor || ""}`.trim() ===
        `${checkoutAddress.floor || ""}`.trim() &&
      `${currentAddress.apartment || ""}`.trim() ===
        `${checkoutAddress.apartment || ""}`.trim()
    );
  };

  hasSelectedAvailableOrderPassAddress = (
    addresses = this.getOrderPassAddressOptionSource(),
  ) =>
    this.getAvailableOrderPassAddresses(addresses).some((savedAddress) =>
      this.currentAddressMatchesOrderPassAddress(savedAddress),
    );

  shouldSkipOrderPassAddressPrompt = (
    addresses = this.getOrderPassAddressOptionSource(),
  ) =>
    this.hasUnchangedSavedContactPhone() &&
    this.hasSelectedAvailableOrderPassAddress(addresses);

  getOrderPassAddressOptionSource = () => {
    if (!this.shouldUseOrderPass()) return [];
    return this.state.orderPassAddressOptions.length
      ? this.state.orderPassAddressOptions
      : this.props.orderPassAddresses || [];
  };

  getOrderPassAddressOrderCount = (address) =>
    Number(address?.order_count || address?.count || 0) || 0;

  getRankedOrderPassAddresses = (
    addresses = this.getOrderPassAddressOptionSource(),
  ) => {
    const availableAddresses = this.getAvailableOrderPassAddresses(addresses);
    const withIndex = availableAddresses.map((address, index) => ({
      address,
      index,
    }));
    const defaultAddress =
      withIndex.find(({ address }) => address?.is_default) ||
      withIndex.find(({ address }) => address?.is_preferred);
    const sortedByOrderCount = withIndex
      .filter(({ address }) => address !== defaultAddress?.address)
      .sort((left, right) => {
        const countDifference =
          this.getOrderPassAddressOrderCount(right.address) -
          this.getOrderPassAddressOrderCount(left.address);
        if (countDifference !== 0) return countDifference;
        return left.index - right.index;
      });

    return [
      ...(defaultAddress ? [defaultAddress.address] : []),
      ...sortedByOrderCount.map(({ address }) => address),
    ];
  };

  getVisibleOrderPassAddresses = () => {
    const rankedAddresses = this.getRankedOrderPassAddresses();
    if (this.state.showAllOrderPassAddressOptions) return rankedAddresses;
    return rankedAddresses.slice(0, 3);
  };

  openOrderPassAddressDialog = (
    addresses = this.state.orderPassAddressOptions,
    { forceAreaSelection = false } = {},
  ) => {
    const orderPassAddressOptions =
      this.getAvailableOrderPassAddresses(addresses);
    if (
      !this.requiresCheckoutAddress({ forceAreaSelection }) ||
      !this.isDeliveryOptionEnabled() ||
      !orderPassAddressOptions.length
    ) {
      return false;
    }

    this.setState({
      orderPassAddressDialogOpen: true,
      orderPassAddressOptions,
      showAllOrderPassAddressOptions: false,
    });
    return true;
  };

  closeOrderPassAddressDialog = () => {
    this.setState({ orderPassAddressDialogOpen: false });
  };

  redirectToPickupBranchSelection = () => {
    this.closeOrderPassAddressDialog();
    this.props.saveAddress({
      selectedDeliveryType: 1,
      pickupArea: null,
      area: null,
      country: null,
      orderPassAddressId: null,
    });
    this.props.history.push("/select/branch", {
      type: 1,
      checkout: true,
    });
  };

  formatOrderPassAddressTitle = (address) => {
    const { language, settings } = this.props;
    const normalizedCountryName = normalizeCountryName(address.country__name);
    const isQatar = normalizedCountryName === "qatar";
    const isEgypt = normalizedCountryName === "egypt";
    const isBahrain = normalizedCountryName === "bahrain";
    let branchName = "";

    if (
      settings.is_branch_based_ordering &&
      address.branch_delivery_charge__branch__name
    ) {
      branchName =
        language == "english"
          ? ` (${address.branch_delivery_charge__branch__name})`
          : ` (${address.branch_delivery_charge__branch__ar_name})`;
    }

    return `${
      language == "english"
        ? address.area__name
        : address.area__ar_name || address.area__name
    }, ${
      language == "english"
        ? isQatar
          ? "Zone"
          : isEgypt
            ? "Area"
            : "Block"
        : isQatar
          ? "منطقة"
          : isEgypt
            ? "منطقة"
            : isBahrain
              ? "مجمع"
              : "قطعة"
    } ${isQatar ? address.zone : address.block}, ${
      language == "english" ? "St." : "شارع"
    } ${address.street}${branchName}`;
  };

  formatOrderPassAddressDetails = (address) => {
    const { language } = this.props;
    const details = [];

    if (address.building) {
      details.push(
        `${language == "english" ? "Building" : "مبنى"} ${address.building}`,
      );
    }
    if (address.floor) {
      details.push(
        `${language == "english" ? "Floor" : "الدور"} ${address.floor}`,
      );
    }
    if (address.apartment) {
      details.push(
        `${language == "english" ? "Apartment" : "شقة"} ${address.apartment}`,
      );
    }
    if (address.additional) {
      details.push(address.additional);
    }

    return details.join(", ");
  };

  applyOrderPassNewAddressContext = (referenceAddress) => {
    const nextAddress = {
      selectedDeliveryType: 0,
      selectedAddressType: 0,
      gpsConfirmed: false,
      country:
        referenceAddress?.country_id ||
        this.props.address?.country ||
        this.props.countries?.[0]?.id ||
        null,
      area: referenceAddress?.area_id || this.props.address?.area || null,
      block: "",
      street: "",
      building: "",
      avenue: "",
      apartment: "",
      floor: "",
      additional: "",
      lat: null,
      lng: null,
      paci: "",
      pickupArea: null,
      orderPassAddressId: null,
    };

    this.props.saveAddress(nextAddress);

    if (
      this.props.settings.is_branch_based_ordering &&
      referenceAddress?.branch_delivery_charge_id &&
      referenceAddress?.branch_delivery_charge__branch__id
    ) {
      this.props.setBranchDeliveryCharge({
        bdc: referenceAddress.branch_delivery_charge_id,
        branch: referenceAddress.branch_delivery_charge__branch__id,
        isPickup: false,
      });
      this.props.updateMOV(
        this.props.branchDeliveryCharges.find(
          (bdc) => bdc.id == referenceAddress.branch_delivery_charge_id,
        )?.minimum_order_value || 0,
      );
    }
  };

  handleSelectOrderPassAddress = (savedAddress) => {
    const hasAppliedSavedAddress = this.applyOrderPassAddress(savedAddress);
    this.closeOrderPassAddressDialog();

    if (!hasAppliedSavedAddress) {
      this.props.history.push("/select/branch");
      return;
    }

    if (this.isAreaSelectionOrderPassEntry() && !this.hasCartItems()) {
      this.props.history.push("/");
      return;
    }

    this.props.history.push("/checkout/confirmation");
  };

  handleCreateOrderPassAddress = () => {
    const referenceAddress = this.getAvailableOrderPassAddresses()[0];
    this.closeOrderPassAddressDialog();
    const orderPassAreaSelectionState =
      this.shouldUseOrderPass() && this.isAreaSelectionOrderPassEntry()
        ? { orderPassEntry: "area_select", newAddress: true }
        : undefined;

    if (!referenceAddress || !this.hasCheckoutAddress()) {
      if (orderPassAreaSelectionState) {
        this.props.history.replace(
          "/select/branch",
          orderPassAreaSelectionState,
        );
      } else {
        this.props.history.push("/select/branch");
      }
      return;
    }

    this.applyOrderPassNewAddressContext(referenceAddress);
    this.props.history.push("/checkout/address", orderPassAreaSelectionState);
  };

  applyOrderPassAddress = (savedAddress) => {
    if (!savedAddress?.checkoutAddress) return false;
    if (
      this.props.settings.is_branch_based_ordering &&
      this.props.branch.branch &&
      savedAddress.branch_delivery_charge__branch__id &&
      this.props.branch.branch !==
        savedAddress.branch_delivery_charge__branch__id
    ) {
      return false;
    }

    this.props.switchAddress(
      savedAddress,
      this.props.settings.is_branch_based_ordering,
    );

    if (this.props.settings.is_branch_based_ordering) {
      this.props.setBranchDeliveryCharge({
        bdc: savedAddress.branch_delivery_charge_id,
        branch: savedAddress.branch_delivery_charge__branch__id,
        isPickup: false,
      });
      this.props.updateMOV(
        this.props.branchDeliveryCharges.find(
          (bdc) => bdc.id == savedAddress.branch_delivery_charge_id,
        )?.minimum_order_value || 0,
      );
    }

    return true;
  };

  getOrderPassHydrationContext = async (
    orderPassAddresses = [],
    { forceAreaSelection = false } = {},
  ) => {
    let areas = this.props.areas || [];
    let branchDeliveryCharges = this.props.branchDeliveryCharges || [];
    let countries = this.props.countries || [];

    if (
      this.requiresCheckoutAddress({ forceAreaSelection }) &&
      (!this.props.fetchedDeliveryCharges || !branchDeliveryCharges.length)
    ) {
      const selectedBranchDeliveryChargeId = this.props.branch?.bdc || null;
      const selectedDeliveryChargeId = branchDeliveryCharges.find(
        (bdc) => bdc.id == selectedBranchDeliveryChargeId,
      )?.delivery_charge;
      const areaNames = getOrderPassSavedAreaNames(orderPassAddresses);
      const payload =
        areaNames.length ||
        selectedBranchDeliveryChargeId ||
        selectedDeliveryChargeId
          ? await this.props.fetchTargetedDeliveryChargesForAreas({
              countryCode: this.props.countryCode,
              areaNames,
              selectedBranchDeliveryChargeId,
              selectedDeliveryChargeId,
            })
          : await this.props.fetchDeliveryCharges(this.props.countryCode);
      if (payload) {
        areas = payload.areas || areas;
        branchDeliveryCharges =
          payload.branch_delivery_charges || branchDeliveryCharges;
        countries = payload.countries || countries;
      }
    }

    return {
      settings: this.props.settings,
      areas,
      branchDeliveryCharges,
      countries,
    };
  };

  getStorefrontOrderPassSyncData = async (
    phoneOverride = null,
    orderPassAddresses = [],
  ) => {
    const hydrationContext =
      await this.getOrderPassHydrationContext(orderPassAddresses);
    return getStorefrontOrderPassSyncData({
      customerContact: {
        name:
          this.props.customerContact?.name ||
          this.props.auth.user?.name ||
          this.state.name,
        email:
          this.props.customerContact?.email ||
          this.props.auth.user?.email ||
          this.state.email,
        phone:
          phoneOverride ||
          this.state.phone ||
          this.props.customerContact?.phone ||
          this.props.auth.user?.phone,
      },
      address: this.props.address,
      authAddresses: this.props.auth.addresses,
      settings: hydrationContext.settings,
      areas: hydrationContext.areas,
      branchDeliveryCharges: hydrationContext.branchDeliveryCharges,
      countries: hydrationContext.countries,
    });
  };

  syncOrderPassInBackground = async (
    syncData,
    storefrontTokenOverride = "",
  ) => {
    const storefrontToken =
      storefrontTokenOverride || this.props.orderPassStorefrontToken;
    if (!syncData?.phone || !storefrontToken) return false;

    try {
      const domain = getOrderPassDomain(this.props.settings, this.props.store);
      const res = await instance.post("/order_pass/storefront_sync/", {
        number: syncData.phone,
        name: syncData.name,
        email: syncData.email,
        addresses: syncData.addresses,
        domain,
        storefront_token: storefrontToken,
      });

      if (res.data?.success) {
        this.props.setOrderPassData({
          phone: syncData.phone,
          addresses:
            res.data?.account?.addresses || this.props.orderPassAddresses || [],
          verifiedPhone: syncData.phone,
          linked: true,
          storefrontToken,
        });
        return true;
      }
    } catch (error) {}

    return false;
  };

  handleHostedOrderPassReturn = async () => {
    const returnEnvelope = getOrderPassReturnData(this.props.location.search);
    if (!returnEnvelope?.authenticated) {
      this.setState({ processingOrderPassReturn: false });
      return false;
    }
    this.setState({ processingOrderPassReturn: true });
    if (!returnEnvelope.redirectCode) {
      const cleanedSearch = clearOrderPassReturnParamsFromSearch(
        this.props.location.search,
      );
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: cleanedSearch,
        state: this.props.history.location.state,
      });
      this.setState({
        processingOrderPassReturn: false,
        phoneError: true,
        phoneErrorText:
          this.props.language === "english"
            ? "Unable to verify orderPass. Please try again."
            : "تعذر التحقق من اوردر باس. حاول مرة أخرى.",
      });
      return true;
    }

    let returnData;
    try {
      const res = await instance.post(
        "/order_pass/storefront_redeem_redirect/",
        {
          code: returnEnvelope.redirectCode,
          domain: getOrderPassDomain(this.props.settings, this.props.store),
        },
      );
      if (!res.data?.success || !res.data?.account) {
        throw new Error(res.data?.message || "Unable to verify orderPass.");
      }
      returnData = {
        authenticated: true,
        name: `${res.data.account.full_name || ""}`.trim(),
        email: `${res.data.account.email || ""}`.trim(),
        phone: normalizeOrderPassPhone(res.data.account.phone_number || ""),
        storefrontToken: `${res.data.storefront_token || ""}`.trim(),
        addresses: Array.isArray(res.data.account.addresses)
          ? res.data.account.addresses
          : [],
      };
    } catch (error) {
      const cleanedSearch = clearOrderPassReturnParamsFromSearch(
        this.props.location.search,
      );
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: cleanedSearch,
        state: this.props.history.location.state,
      });
      this.setState({
        processingOrderPassReturn: false,
        phoneError: true,
        phoneErrorText:
          this.props.language === "english"
            ? "Your orderPass session expired. Please try again."
            : "انتهت جلسة اوردر باس. حاول مرة أخرى.",
      });
      return true;
    }

    const previousVerifiedPhone = normalizeOrderPassPhone(
      this.props.orderPassVerifiedPhone,
    );
    const returnedPhone = normalizeOrderPassPhone(returnData.phone);
    const switchedOrderPassPhone =
      !!previousVerifiedPhone &&
      !!returnedPhone &&
      previousVerifiedPhone !== returnedPhone;
    const shouldPromptAddressForAreaSelection =
      this.isAreaSelectionOrderPassEntry();

    const localData = switchedOrderPassPhone
      ? null
      : await this.getStorefrontOrderPassSyncData(
          returnData.phone,
          returnData?.addresses || [],
        );
    const hydrationContext = await this.getOrderPassHydrationContext(
      returnData?.addresses || [],
      { forceAreaSelection: shouldPromptAddressForAreaSelection },
    );
    const hydratedAddresses = hydrateOrderPassAddresses(
      returnData?.addresses,
      hydrationContext,
    );
    const orderPassCustomer = {
      name: returnData?.name || "",
      email: returnData?.email || "",
      phone: returnData?.phone || this.state.phone,
      civilID: "",
    };
    const availableAddresses =
      this.getAvailableOrderPassAddresses(hydratedAddresses);
    const shouldKeepCompleteLocalAddress =
      !switchedOrderPassPhone && this.hasCompleteLocalDeliveryAddress();

    this.props.setOrderPassData({
      phone: orderPassCustomer.phone,
      addresses: hydratedAddresses,
      verifiedPhone: orderPassCustomer.phone,
      linked: true,
      storefrontToken: returnData?.storefrontToken || "",
    });

    if (
      switchedOrderPassPhone &&
      this.props.address?.selectedDeliveryType === 0
    ) {
      await this.props.saveAddress({
        selectedDeliveryType: 0,
        selectedAddressType: 0,
        gpsConfirmed: false,
        country: null,
        area: null,
        block: "",
        street: "",
        building: "",
        avenue: "",
        apartment: "",
        floor: "",
        additional: "",
        lat: null,
        lng: null,
        paci: "",
        pickupArea: null,
        orderPassAddressId: null,
      });
      this.props.setBranchDeliveryCharge({
        bdc: null,
        branch: null,
        isPickup: false,
      });
    }

    this.setState({
      name: orderPassCustomer.name,
      email: orderPassCustomer.email,
      phone: orderPassCustomer.phone,
      phoneFieldKey: Math.random() * 999999,
      showForm: !this.canSkipOrderPassForm(orderPassCustomer),
      phoneError: false,
      phoneErrorText: "",
      orderPassAddressOptions: availableAddresses,
      redirectingToOrderPass: false,
    });

    const cleanedSearch = clearOrderPassReturnParamsFromSearch(
      this.props.location.search,
    );
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: cleanedSearch,
      state: this.props.history.location.state,
    });

    if (
      shouldSyncStorefrontOrderPassData({
        returnedData: returnData,
        localData,
      })
    ) {
      this.syncOrderPassInBackground(
        {
          ...localData,
          phone: orderPassCustomer.phone,
        },
        returnData?.storefrontToken || "",
      );
    }

    if (!this.canSkipOrderPassForm(orderPassCustomer)) {
      await this.props.saveCustomerContact(orderPassCustomer);
      this.setState({
        showForm: true,
        processingOrderPassReturn: false,
      });
      return true;
    }

    await this.props.saveCustomerContact(orderPassCustomer);

    if (this.shouldUsePickupFlowAfterOrderPass()) {
      this.redirectToPickupBranchSelection();
      return true;
    }

    if (
      !shouldKeepCompleteLocalAddress &&
      this.openOrderPassAddressDialog(availableAddresses, {
        forceAreaSelection: shouldPromptAddressForAreaSelection,
      })
    ) {
      this.setState({ processingOrderPassReturn: false });
      return true;
    }

    if (
      (this.requiresCheckoutAddress() || shouldPromptAddressForAreaSelection) &&
      (switchedOrderPassPhone || !this.hasCheckoutAddress())
    ) {
      this.props.history.push("/select/branch", {
        type:
          this.isPickupOptionEnabled() && !this.isDeliveryOptionEnabled()
            ? 1
            : 0,
        checkout: true,
      });
      return;
    }

    this.props.history.push("/checkout/confirmation");
    return true;
  };

  redirectToOrderPass = ({ force = false } = {}) => {
    if (!this.validatePhone()) return;
    if (
      !force &&
      !this.state.orderPassHasSavedAddresses &&
      !this.state.orderPassHasAccount
    ) {
      this.handleContinueAsGuest();
      return;
    }

    this.setState({
      redirectingToOrderPass: true,
      phoneError: false,
      phoneErrorText: "",
    });
    this.props.clearOrderPassGuestBypass();

    const returnUrl = `${window.location.origin}${
      this.props.location.pathname
    }${clearOrderPassReturnParamsFromSearch(this.props.location.search)}`;

    window.location.assign(
      buildOrderPassRedirectUrl({
        settings: this.props.settings,
        store: this.props.store,
        phone: this.state.phone,
        returnUrl,
      }),
    );
  };

  handleContinueAsGuest = () => {
    if (!this.validatePhone()) return;

    this.props.setOrderPassGuestBypass(this.state.phone);
    this.setState({
      showForm: true,
      redirectingToOrderPass: false,
      phoneError: false,
      phoneErrorText: "",
    });
  };

  canContinueCurrentPhoneAsGuest = () =>
    this.shouldUseOrderPass() &&
    !this.props.auth?.user &&
    this.requiresOrderPassVerification(this.state.phone) &&
    this.isValidPhoneValue(this.state.phone);

  isGuestEditingSavedContactPhone = () => {
    if (!this.shouldUseOrderPass() || !this.state.showForm) return false;
    if (this.props.auth?.user) return false;
    if (
      this.props.orderPassVerifiedPhone ||
      this.props.orderPassStorefrontToken
    ) {
      return false;
    }

    const savedPhone = normalizeOrderPassPhone(
      this.props.customerContact?.phone,
    );
    const currentPhone = normalizeOrderPassPhone(this.state.phone);

    return !!savedPhone && !!currentPhone && savedPhone !== currentPhone;
  };

  handleNext = async (location) => {
    const { settings } = this.props;

    if (this.hasChangedVerifiedOrderPassPhone()) {
      this.redirectToOrderPass({ force: true });
      return;
    }

    if (this.shouldUseOrderPass() && this.requiresOrderPassVerification()) {
      if (this.state.showForm && this.canContinueCurrentPhoneAsGuest()) {
        this.props.setOrderPassGuestBypass(this.state.phone);
      } else {
        this.redirectToOrderPass();
        return;
      }
    }

    let error = false;
    if (!this.state.name.trim()) {
      error = true;
      this.setState({ nameError: true });
    } else if (this.state.name.trim().length > 25) {
      error = true;
      this.setState({ nameLengthError: true });
    }
    if (settings.email_required && !validateEmail(this.state.email?.trim())) {
      error = true;
      this.setState({ emailError: true });
    }
    if (
      this.props.settings.ask_for_civil_id &&
      (!this.state.civilID || !this.state.civilID.trim())
    ) {
      error = true;
      this.setState({ civilIDError: true });
    }

    if (!this.validatePhone()) error = true;

    if (!error) {
      if (
        this.props.settings.enable_aseer_time &&
        this.props.auth?.user &&
        this.props.customerContact?.phone != this.state.phone
      ) {
        this.setState({ verifyPhoneModalOpen: true });
      } else {
        await this.props.saveCustomerContact(this.state);
        if (
          this.shouldUseOrderPass() &&
          this.isOrderPassVerified(this.state.phone)
        ) {
          const syncData = await this.getStorefrontOrderPassSyncData(
            this.state.phone,
          );
          this.syncOrderPassInBackground(syncData);
        }
        if (
          this.shouldUseOrderPass() &&
          location === "/checkout/confirmation" &&
          !this.shouldSkipOrderPassAddressPrompt() &&
          this.openOrderPassAddressDialog()
        ) {
          return;
        }
        if (
          this.shouldUseOrderPass() &&
          location === "/checkout/confirmation" &&
          this.isOrderPassVerified(this.state.phone) &&
          this.props.orderPassStorefrontToken
        ) {
          const refreshedOrderPassData =
            await this.props.refreshStorefrontOrderPassData();
          if (
            refreshedOrderPassData?.addresses?.length &&
            !this.shouldSkipOrderPassAddressPrompt(
              refreshedOrderPassData.addresses,
            ) &&
            this.openOrderPassAddressDialog(refreshedOrderPassData.addresses)
          ) {
            return;
          }
          if (
            !this.shouldSkipOrderPassAddressPrompt() &&
            this.openOrderPassAddressDialog()
          ) {
            return;
          }
        }
        if (this.props.settings.enable_dot) {
          this.props.createCustomerWithAddressAndPhone();
        }
        this.props.history.push(location);
      }
    }
  };
  handleBirthdayChange = (date) => {
    this.setState({ birthday: date });
  };
  handleChangeOptInMarketing = (check) => {
    this.setState({ optInMarketing: check });
  };

  handleChangeContactChannel = (channel) => {
    this.setState({ contactChannel: channel });
  };

  render() {
    const { language, settings } = this.props;
    const { showForm } = this.state;
    const OrderPassLogo = language === "arabic" ? OrderPassArabic : OrderPass;
    const orderPassAddressOptions = this.getAvailableOrderPassAddresses();
    const visibleOrderPassAddressOptions = this.getVisibleOrderPassAddresses();
    const hasMoreOrderPassAddressOptions =
      orderPassAddressOptions.length > visibleOrderPassAddressOptions.length;
    const hasValidOrderPassPhone =
      this.shouldUseOrderPass() && this.isValidPhoneValue(this.state.phone);
    const shouldShowOrderPassCta =
      hasValidOrderPassPhone &&
      (this.state.orderPassHasSavedAddresses === true ||
        this.state.orderPassHasAccount === true) &&
      !this.state.orderPassPhoneCheckLoading;
    const shouldShowGuestCta =
      hasValidOrderPassPhone && !this.state.orderPassPhoneCheckLoading;
    const isGuestEditingSavedContactPhone =
      this.isGuestEditingSavedContactPhone();
    const shouldShowOrderPassEditCta =
      isGuestEditingSavedContactPhone &&
      hasValidOrderPassPhone &&
      (this.state.orderPassHasSavedAddresses === true ||
        this.state.orderPassHasAccount === true) &&
      !this.state.orderPassPhoneCheckLoading;
    const shouldShowOrderPassEditLoading =
      isGuestEditingSavedContactPhone &&
      hasValidOrderPassPhone &&
      this.state.orderPassPhoneCheckLoading;
    const isOrderPassGate = this.shouldUseOrderPass() && !showForm;
    let previousPath;
    if (this.props.history.location.state) {
      previousPath = this.props.history.location.state.prevPath;
    }

    if (
      this.state.processingOrderPassReturn ||
      this.state.redirectingToOrderPass
    ) {
      return (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{
            minHeight: "100vh",
            backgroundColor: "white",
            padding: 24,
          }}
        >
          <div
            className="text-center mx-auto"
            style={{
              width: "100%",
              maxWidth: 360,
              border: "1px solid #eef2ff",
              borderRadius: 28,
              padding: "36px 24px",
              boxShadow: "0 18px 48px rgba(0, 65, 194, 0.12)",
            }}
          >
            <OrderPassLogo height={38} width={160} />
            <div
              className="mx-auto"
              style={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                border: "4px solid rgba(0, 65, 194, 0.12)",
                borderTopColor: "#0041C2",
                marginTop: 28,
                animation: "orderpass-spin 0.8s linear infinite",
              }}
            />
            <p
              className="bold mb-2"
              style={{
                color: "#1E293B",
                fontSize: 18,
                marginTop: 24,
              }}
            >
              {this.state.redirectingToOrderPass
                ? language === "english"
                  ? "Opening orderPass"
                  : "جاري فتح اوردر باس"
                : language === "english"
                  ? "Resuming checkout"
                  : "جاري استكمال الطلب"}
            </p>
            <p className="mb-0" style={{ color: "#7a8496", lineHeight: 1.6 }}>
              {this.state.redirectingToOrderPass
                ? language === "english"
                  ? "Taking you to orderPass to verify your phone."
                  : "سيتم تحويلك إلى اوردر باس لتأكيد رقمك."
                : language === "english"
                  ? "Loading your saved details and matching addresses."
                  : "جاري تحميل بياناتك المحفوظة ومطابقة العناوين."}
            </p>
            <style>
              {`@keyframes orderpass-spin { to { transform: rotate(360deg); } }`}
            </style>
          </div>
        </div>
      );
    }

    return (
      <div
        className="  w-100 mx-0 "
        style={{
          backgroundColor: "white",
          minHeight: 690,
        }}
      >
        {previousPath !== "/checkout/confirmation" ? (
          <ProductHeader
            onBack={
              this.shouldUseOrderPass() && this.isAreaSelectionOrderPassEntry()
                ? () => this.props.history.replace("/")
                : undefined
            }
          />
        ) : (
          <ProductHeader
            onBack={() => this.props.history.push("/checkout/confirmation")}
          />
        )}

        {this.state.verifyPhoneModalOpen && (
          <VerifyPhone
            open={this.state.verifyPhoneModalOpen}
            onClose={async (verified) => {
              if (verified) {
                this.props.saveCustomerContact(this.state);
                await this.props.createCustomerWithAddressAndPhone(true);

                window.location.replace(
                  previousPath === "profile"
                    ? "/profile"
                    : "/checkout/confirmation",
                );
              }
              this.setState({ verifyPhoneModalOpen: false });
            }}
            phone={this.state.phone}
            history={this.props.history}
            disableEditing={true}
          />
        )}
        {this.state.orderPassAddressDialogOpen && (
          <Dialog
            open={this.state.orderPassAddressDialogOpen}
            onClose={(event, reason) => {
              if (["backdropClick", "escapeKeyDown"].includes(reason)) return;
              this.closeOrderPassAddressDialog();
            }}
            aria-labelledby="orderpass-address-dialog-title"
            PaperProps={{
              style: orderPassModalPaperStyle({
                width: 420,
                maxWidth: "calc(100% - 24px)",
              }),
            }}
          >
            <DialogTitle
              id="orderpass-address-dialog-title"
              style={orderPassModalTitleStyle(language)}
            >
              {language === "english"
                ? "Choose a saved address"
                : "اختر عنوانا محفوظا"}
            </DialogTitle>
            <DialogContent style={orderPassModalContentStyle()}>
              {visibleOrderPassAddressOptions.map((savedAddress) => (
                <button
                  type="button"
                  key={savedAddress.id}
                  onClick={() =>
                    this.handleSelectOrderPassAddress(savedAddress)
                  }
                  style={{
                    width: "100%",
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    backgroundColor: "#fff",
                    padding: "14px 16px",
                    textAlign: language === "arabic" ? "right" : "left",
                    marginBottom: 12,
                    cursor: "pointer",
                  }}
                >
                  <p
                    className="mb-1 bold"
                    style={{ color: "#333", fontSize: 14 }}
                  >
                    {this.formatOrderPassAddressTitle(savedAddress)}
                  </p>
                  <p
                    className="mb-0"
                    style={{ color: "#666", fontSize: 13, lineHeight: 1.5 }}
                  >
                    {this.formatOrderPassAddressDetails(savedAddress)}
                  </p>
                </button>
              ))}
              {hasMoreOrderPassAddressOptions && (
                <Button
                  variant="outlined"
                  color="primary"
                  disableElevation
                  onClick={() =>
                    this.setState({ showAllOrderPassAddressOptions: true })
                  }
                  style={orderPassButtonStyle({
                    width: "100%",
                  })}
                >
                  {language === "english" ? "Show more ↓" : "عرض المزيد ↓"}
                </Button>
              )}
            </DialogContent>
            <DialogActions
              style={orderPassModalActionsStyle({
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              })}
            >
              <Button
                variant="outlined"
                color="primary"
                disableElevation
                onClick={this.handleCreateOrderPassAddress}
                style={orderPassButtonStyle({
                  width: "100%",
                  marginBottom: this.isPickupOptionEnabled() ? 12 : 0,
                })}
              >
                {language === "english"
                  ? "Create a new address"
                  : "إنشاء عنوان جديد"}
              </Button>
              {this.isPickupOptionEnabled() && (
                <Button
                  variant="text"
                  color="primary"
                  disableElevation
                  onClick={this.redirectToPickupBranchSelection}
                  style={orderPassButtonStyle({
                    width: "100%",
                    marginLeft: 0,
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  })}
                >
                  {language === "english"
                    ? "Pick up instead"
                    : "الاستلام من الفرع بدلا من ذلك"}
                </Button>
              )}
            </DialogActions>
          </Dialog>
        )}
        <div
          className={isOrderPassGate ? "w-100" : "border-top w-100"}
          style={{
            marginTop: isOrderPassGate ? 0 : 55,

            backgroundColor: "white",
          }}
        >
          {!isOrderPassGate &&
            previousPath !== "/checkout/confirmation" &&
            previousPath !== "profile" && (
              <MyStepper
                selected={language == "english" ? 0 : 1}
                numberOfSteps={
                  (this.props.settings.enable_delivery ||
                    this.props.settings.enable_pickup) &&
                  (this.props.cart.charged_items > 0 ||
                    this.props.cart.delivered_items > 0)
                    ? 2
                    : 1
                }
              />
            )}

          {!isOrderPassGate && (
            <>
              <Logo width="100" height="100" style={{ marginTop: 98 }} />

              <p className="text-muted mt-3 mb-3 bold" style={{ fontSize: 22 }}>
                {language == "english"
                  ? "Contact Information"
                  : "بيانات التواصل"}
              </p>
            </>
          )}
          {/* <p className="mx-auto w-75" style={{ fontSize: 15, color: "#999" }}>
            {language == "english"
              ? "We need this information to contact you and get the order delivered"
              : "نحتاج هذي المعلومات لنتواصل معك واتمام عملية التوصيل"}
          </p> */}
          <div style={{ marginTop: isOrderPassGate ? 0 : 35 }}>
            {!this.shouldUseOrderPass() && (
              <SignUp
                onContinueAsGuest={() => {
                  this.setState({ showForm: true });
                  window.setTimeout(
                    () => window.scrollTo({ top: 10000, behavior: "smooth" }),
                    50,
                  );
                }}
              />
            )}
          </div>
          {this.shouldUseOrderPass() && !showForm && (
            <div
              className="w-100 px-4"
              style={{
                marginTop: 0,
                paddingTop: 120,
              }}
            >
              <div
                className="mx-auto"
                style={{
                  color: "#333",
                  maxWidth: 430,
                  fontSize: 22,
                  lineHeight: 1.35,
                  fontWeight: 700,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 14,
                  textAlign: "center",
                  direction: language === "english" ? "ltr" : "rtl",
                  marginBottom: 42,
                }}
              >
                <span
                  style={{
                    width: 82,
                    height: 82,
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, rgba(0,153,204,0.12), rgba(0,153,204,0.04))",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 14px 30px rgba(0, 153, 204, 0.14)",
                  }}
                >
                  <PhoneIcon style={{ color: "#0099cc", fontSize: 44 }} />
                </span>
                <span>
                  {language === "english"
                    ? "Enter your phone number to proceed with checkout"
                    : "أدخل رقم هاتفك للمتابعة إلى الدفع"}
                </span>
              </div>
              <MuiPhoneNumber
                defaultCountry={this.props.store?.default_dial_code || "kw"}
                onlyCountries={
                  this.props.settings.show_all_country_codes
                    ? []
                    : [
                        "kw",
                        "sa",
                        "qa",
                        "om",
                        "ae",
                        "bh",
                        "sy",
                        "lb",
                        "jo",
                        "eg",
                        "us",
                        "uk",
                        "cn",
                      ]
                }
                excludeCountries={["il"]}
                countryCodeEditable={false}
                disableAreaCodes={true}
                error={this.state.phoneError}
                label={language === "english" ? "Phone *" : "رقم الهاتف *"}
                InputLabelProps={
                  language === "arabic"
                    ? {
                        style: {
                          left: "auto",
                          right: 0,
                          textAlign: "right",
                          transformOrigin: "top right",
                          width: "100%",
                          direction: "rtl",
                        },
                      }
                    : undefined
                }
                FormHelperTextProps={
                  language === "arabic"
                    ? {
                        style: {
                          textAlign: "right",
                          direction: "rtl",
                        },
                      }
                    : undefined
                }
                className="mt-4 mb-3"
                color="primary"
                onChange={this.handleChange}
                key={this.state.phoneFieldKey}
                value={this.state.phone}
                autoComplete="tel"
                autoFocus
                inputProps={{ inputMode: "tel" }}
                fullWidth
                helperText={
                  this.state.phoneError
                    ? this.state.phoneErrorText !== ""
                      ? this.state.phoneErrorText
                      : language === "english"
                        ? "Please enter your phone number"
                        : "الرجاء ادخال رقم الهاتف"
                    : ""
                }
              />
              {this.state.orderPassPhoneCheckLoading &&
                hasValidOrderPassPhone && (
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    disabled={true}
                    style={orderPassButtonStyle({
                      width: "100%",
                      marginTop: 12,
                      direction: language === "arabic" ? "rtl" : "ltr",
                    })}
                  >
                    {language === "english"
                      ? "Checking your saved details..."
                      : "جاري التحقق من بياناتك المحفوظة..."}
                  </Button>
                )}
              {shouldShowOrderPassCta && (
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  onClick={this.redirectToOrderPass}
                  disabled={this.state.redirectingToOrderPass}
                  style={orderPassButtonStyle({
                    width: "100%",
                    marginTop: 12,
                    direction: language === "arabic" ? "rtl" : "ltr",
                  })}
                >
                  {this.state.redirectingToOrderPass ? (
                    language === "english" ? (
                      "Redirecting to orderPass..."
                    ) : (
                      "جاري التحويل إلى اوردر باس..."
                    )
                  ) : (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                        direction: language === "arabic" ? "rtl" : "ltr",
                      }}
                    >
                      <span>
                        {language === "english"
                          ? "Quick checkout with"
                          : "دفع سريع باستخدام"}
                      </span>
                      <OrderPassLogo
                        height={18}
                        width={88}
                        style={{ filter: "brightness(0) invert(1)" }}
                      />
                    </span>
                  )}
                </Button>
              )}
              {shouldShowGuestCta && (
                <Button
                  variant={shouldShowOrderPassCta ? "outlined" : "contained"}
                  color="primary"
                  disableElevation
                  onClick={this.handleContinueAsGuest}
                  style={orderPassButtonStyle({
                    width: "100%",
                    marginTop: 12,
                  })}
                >
                  {language === "english"
                    ? "Continue as guest"
                    : "المتابعة كضيف"}
                </Button>
              )}
            </div>
          )}
          {showForm && (
            <>
              <UserForm
                firstStepRef={this.firstStepRef}
                name={this.state.name}
                civilID={this.state.civilID}
                phone={this.state.phone}
                setPhone={(phone) => this.setState({ phone: phone })}
                email={this.state.email}
                emailError={this.state.emailError}
                handleChange={this.handleChange}
                nameError={this.state.nameError}
                nameLengthError={this.state.nameLengthError}
                civilIDError={this.state.civilIDError}
                phoneError={this.state.phoneError}
                setPhoneError={(err) => this.setState({ phoneError: err })}
                phoneErrorText={this.state.phoneErrorText}
                setPhoneErrorText={(e) => this.setState({ phoneErrorText: e })}
                dateValue={this.state.birthday}
                onChangeDate={this.handleBirthdayChange}
                highlightColor="#0099cc"
                phoneFieldKey={this.state.phoneFieldKey}
                optInMarketing={this.state.optInMarketing}
                contactChannel={this.state.contactChannel}
                handleChangeOptInMarketing={this.handleChangeOptInMarketing}
                handleChangeContactChannel={this.handleChangeContactChannel}
                afterPhoneContent={
                  this.shouldUseOrderPass() ? (
                    <>
                      {shouldShowOrderPassEditLoading && (
                        <Button
                          variant="contained"
                          color="primary"
                          disableElevation
                          disabled={true}
                          style={orderPassButtonStyle({
                            width: "100%",
                            marginTop: 4,
                            marginBottom: 12,
                          })}
                        >
                          {language === "english"
                            ? "Checking your saved details..."
                            : "جاري التحقق من بياناتك المحفوظة..."}
                        </Button>
                      )}
                      {shouldShowOrderPassEditCta && (
                        <Button
                          variant="outlined"
                          color="primary"
                          disableElevation
                          onClick={() =>
                            this.redirectToOrderPass({ force: true })
                          }
                          disabled={this.state.redirectingToOrderPass}
                          style={orderPassButtonStyle({
                            width: "100%",
                            marginTop: 4,
                            marginBottom: 12,
                          })}
                        >
                          {language === "english"
                            ? "Continue with orderPass"
                            : "المتابعة باستخدام اوردر باس"}
                        </Button>
                      )}
                    </>
                  ) : null
                }
              />
              <div style={{ height: 250, background: "white" }}></div>
              {previousPath === "profile" ||
              previousPath === "/checkout/confirmation" ? (
                <ActionButton
                  action={language == "english" ? "Save" : "حفظ"}
                  onClick={() =>
                    this.handleNext(
                      previousPath === "profile"
                        ? "/profile"
                        : "/checkout/confirmation",
                    )
                  }
                  color="#0099cc"
                />
              ) : (
                <ActionButton
                  action={language == "english" ? "Next" : "التالي"}
                  onClick={() => this.handleNext("/checkout/confirmation")}
                  color="#0099cc"
                />
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customerContact: state.customers.customerContact,
    orderPassAddresses: state.customers.orderPassAddresses || [],
    orderPassVerifiedPhone: state.customers.orderPassVerifiedPhone,
    orderPassStorefrontToken: state.customers.orderPassStorefrontToken,
    orderPassGuestBypassPhone: state.customers.orderPassGuestBypassPhone,
    address: state.customers.address,
    settings: state.store.store.settings,
    cart: state.cart,
    auth: state.auth,
    areas: state.store.store.areas,
    branchDeliveryCharges: state.store.store.branch_delivery_charges,
    countries: state.store.store.all_countries || state.store.store.countries,
    fetchedDeliveryCharges: state.store.fetchedDeliveryCharges,
    branch: state.branch,
    branches: state.store.store.branches,
    store: state.store.store,
    countryCode: state.store.store.country_code,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveCustomerContact: (customer) => dispatch(saveCustomerContact(customer)),
    createCustomerWithAddressAndPhone: (withoutAddress) =>
      dispatch(createCustomerWithAddressAndPhone(withoutAddress)),
    setOrderPassData: (data) => dispatch(setOrderPassData(data)),
    setOrderPassGuestBypass: (phone) =>
      dispatch(setOrderPassGuestBypass(phone)),
    clearOrderPassGuestBypass: () => dispatch(clearOrderPassGuestBypass()),
    switchAddress: (adrs, isBranchBased) =>
      dispatch({
        type: "SWITCH_ADDRESS",
        payload: { address: adrs, isBranchBased: isBranchBased },
      }),
    setBranchDeliveryCharge: (bdcObj) =>
      dispatch(setBranchDeliveryCharge(bdcObj)),
    updateMOV: (mov) => dispatch(updateMOV(mov)),
    saveAddress: (address) => dispatch(saveAddress(address)),
    fetchDeliveryCharges: (countryCode) =>
      dispatch(fetchDeliveryCharges(countryCode)),
    fetchTargetedDeliveryChargesForAreas: (payload) =>
      dispatch(fetchTargetedDeliveryChargesForAreas(payload)),
    refreshStorefrontOrderPassData: () =>
      dispatch(refreshStorefrontOrderPassData()),
  };
};

export { validateEmail };
export default connect(mapStateToProps, mapDispatchToProps)(index);
